






























import Vue from "vue";
import Component from "vue-class-component";

import {
  DisplayModule,
  RouterModule,
  SectionsModule,
  ArgumentsModule,
  UsersModule,
  VotingModule,
  CommentsModule
} from "@/store/store.helper";

import { colorDirective } from "@/directives/color-directive";
import { Prop } from "vue-property-decorator";
import * as enums from '@/types/enums';
@Component({
  directives: {
    colorDirective
  }
})
export default class ownerData extends Vue {
  @Prop() public item: Object;
  @Prop() public itemContent: String;
  @Prop() public itemContentHtml: String;

  @DisplayModule.DisplayGetter private dateFormatted;
  @UsersModule.UsersGetter private participantDisplayNameById;
  @UsersModule.UsersGetter private participantPhotoUrlById;

  @RouterModule.RouterGetter public getPath;
  @RouterModule.RouterAction private push;

  private clipFlag: boolean = false;

  private mounted() {
    if(this.$refs.content && this.$refs.content['clientHeight'] > 80) {
      this.$refs.content['classList'].add('clip');
      this.clipFlag = true;
    }
  }

  private showMore() {
    this.$refs.content['classList'].remove('clip');
    this.clipFlag = false;
  }

  private goToSignal() {
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        [enums.SECTION_BY.sectionById]: this.item['id'],
        index: 1,
      },
    });
    this.push({ path });
  }
}
